import { AlkLogger } from '@alk/core';
import { CurrencyAmountCellRendererBase } from './currency-pair-amount-cell-renderer.base';
import { _ as Utils } from '@ag-grid-community/core';
export class CurrencyPairAmountCellRendererComponent extends CurrencyAmountCellRendererBase {
    init(params) {
        const hasCurrencyKeyParam = Boolean(params.currencyKey);
        const hasFixedCurrencyParam = Boolean(params.fixedCurrency);
        const hasCurrenciesSplitParams = (Boolean(params.currenciesSplitKey) &&
            (typeof (params.getCurrencyFromCurrenciesSplit) === 'function'));
        const hasOptionalParamsSet = hasCurrencyKeyParam || hasFixedCurrencyParam;
        const hasMinimalParamsSet = hasOptionalParamsSet || hasCurrenciesSplitParams;
        this.currenciesSplitKey = params.currenciesSplitKey;
        if (!Boolean(this.currenciesSplitKey) && !hasOptionalParamsSet) {
            // eslint-disable-next-line max-len
            AlkLogger.warn('[CurrencyPairAmountCellRenderer] The \'currenciesSplitKey\' field in the \'cellRendererParams\' should be specified for the amount cell renderer to display the currency.');
        }
        this.getCurrencyFromCurrenciesSplit = params.getCurrencyFromCurrenciesSplit;
        if (typeof (this.getCurrencyFromCurrenciesSplit) !== 'function' && !hasOptionalParamsSet) {
            // eslint-disable-next-line max-len
            AlkLogger.warn('[CurrencyPairAmountCellRenderer] The \'getCurrencyFromCurrenciesSplit\' field in the \'cellRendererParams\' should be specified for the amount cell renderer to display the currency.');
        }
        if (!hasMinimalParamsSet) {
            // eslint-disable-next-line max-len
            AlkLogger.warn('[CurrencyPairAmountCellRenderer] Either \'currenciesSplitKey\' with \'getCurrencyFromCurrenciesSplit\', \'currencyKey\' or \'fixedCurrency\' field in the \'cellRendererParams\' should be specified for the amount cell renderer to display the currency.');
        }
        super.init(params);
    }
    isValueAGroupingKey(params) {
        return params.node.group && params.value === params.node.key;
    }
    getValueObjectFromGroupingKey(params) {
        return JSON.parse(params.value);
    }
    updateDOM(params) {
        const data = this.isValueAGroupingKey(params) ?
            this.getValueObjectFromGroupingKey(params) :
            params.value;
        if (Utils.exists(data === null || data === void 0 ? void 0 : data.currency)) {
            this.eCurrency.innerHTML = data.currency;
        }
        if (Utils.exists(params.valueFormatted)) {
            this.eValue.innerHTML = params.valueFormatted;
            return;
        }
        if (Utils.exists(params.value)) {
            this.eValue.innerHTML = this.lastValue.toString();
            return;
        }
    }
}
